import { PropsWithChildren } from 'react';
import { scrollbarStyles } from '@styles';
import Link from 'next/link';
import Image from '@components/elements/image/image';
import cn from 'classnames';
import styles from './card.module.scss';
import { Maybe } from '@crocodille/common';

interface CardRowProps {
  readonly isMargin?: boolean;
}

export const CardRow: React.FC<PropsWithChildren<CardRowProps>> = ({
  children,
  isMargin,
}) => {
  return (
    <div
      className={cn(styles.row, {
        [styles.margin]: isMargin,
      })}
    >
      <div className={cn(styles.rowInner, scrollbarStyles.scrollable)}>
        {children}
      </div>
    </div>
  );
};

interface CardProps {
  readonly link: string;
  readonly small?: boolean;
  readonly imageSrc?: Maybe<string>;
  readonly name: string;
  readonly smallImage?: boolean;
}

const Card: React.FC<React.PropsWithChildren<CardProps>> = ({
  children,
  link,
  small,
  imageSrc,
  name,
  smallImage,
}) => {
  return (
    <Link
      className={cn({ [styles.card]: true, [styles.small]: small })}
      href={link}
    >
      <div className={styles.imageOuterContainer}>
        <div
          className={cn(styles.imageContainer, {
            [styles.smallImage]: smallImage,
          })}
        >
          <Image
            className={styles.image}
            src={imageSrc ?? null}
            alt={name}
            sizes="(max-width: 767px) 33vw, (max-width: 1023px) 50vw, 33vw"
            fill
          />
        </div>
      </div>
      <div className={styles.content}>{children}</div>
    </Link>
  );
};

export default Card;
